import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./resetPassword.css";
import { Input, Modal } from "antd";
import { getMetaCsrf } from "../../util/basicRenders";

const REGEX_UPPER_CASE = /[A-Z]+/;
const REGEX_DIGI_CASE = /[0-9]+/;
const REGEX_SYMBOL_CASE = /[$&+,:;=?@#|'<>.^*()%!-]+/;

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [succeess,setSucceess] = useState("");
  const [weakPassword, setWeakPassword] = useState("");

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const tokenParam = query.get("token");
    if (tokenParam) {
      setToken(tokenParam);
    } else {
      navigate("/"); // Redirect if no token is present
    }
  }, [location, navigate]);

  const handleSubmit = async e => {
    e.preventDefault();

    if (newPassword && (newPassword.length < 8 || !REGEX_DIGI_CASE.test(newPassword) || !REGEX_UPPER_CASE.test(newPassword) || !REGEX_SYMBOL_CASE.test(newPassword))) {
      setError("Password is not strong enough.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      // Replace with your API endpoint
      const response = await fetch("/api/user/resetpassword", {
        method: "POST",
        headers: { "Content-Type": "application/json",
        "x-csrf-token": getMetaCsrf() },
        body: JSON.stringify({ token, newPassword })
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.msg || "Error resetting password");
      }

      // alert("Password reset successful");
      setSucceess("Password reset successful")
      navigate("/login");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="reset-password" id="reset-password-page">
      <form className="reset" id="reset-password-page-form" onSubmit={handleSubmit}>
        <header id="reset-password-header">
          <h1 id="reset-title">Reset Password</h1>
        </header>
        <div className="form-group" id="reset-password-page-form">
          <Input
            id="inputPassword"
            type="password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            placeholder="Enter your new password"
            required
          />
        </div>
        <div className="form-group" id="reset-password-page-form-2">
          <Input
            id="inputPassword"
            type="password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            placeholder="Confirm your new password"
            required
          />
        </div>
        {error && <p style={{ color: "red", textAlign:"left" }}>{error}</p>}
        {succeess && <p style={{ color: "green" }}>{succeess}</p>}
        <button className="cursor-pointer" id="reset-password=page-form-button" type="submit">Reset Password</button>
      </form>
      <div id="info-text">
        <span>
          Please fill in all fields to reset your password.
        </span>
      </div>
    </div>
  );
};

export default ResetPassword;
